<template>
  <div>
    お使いのブラウザでは無理なのです
    
    <router-link to="/">ホーム</router-link>
  </div>
</template>

<script>
export default {
  name: 'dissatisfy'
}
</script>

<style>

</style>
